/**
 * What erasure leaves in a text column: exactly `{"redacted":true}`. Every room screen that shows a server
 * value goes through here, so that nobody reads the raw shell. The server refuses a session for an erased
 * subject, so this is the last line. Only the exact shell counts, as in the console's own formatter.
 */
const DIGEST = /^[0-9a-f]{64}$/;

export function isErased(v: unknown): boolean {
  if (typeof v !== 'string') return false;
  const text = v.trim();
  if (!text.startsWith('{') || !text.includes('redacted')) return false;
  try {
    const o = JSON.parse(text) as Record<string, unknown>;
    if (!o || typeof o !== 'object' || Array.isArray(o) || o.redacted !== true) return false;
    const keys = Object.keys(o);
    return keys.length === 1 || (keys.length === 2 && typeof o.value_sha256 === 'string' && DIGEST.test(o.value_sha256));
  } catch {
    return false;
  }
}

/** The text as it was, or the localized label when it is a shell. */
export function erasedOr(v: string, label: string): string {
  return isErased(v) ? label : v;
}
